






















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { LiteratureViewModel, LiteratureService } from '../../api/literature';
@Component({})
export default class LiteratureIndex extends Vue {
  private service: LiteratureService = new LiteratureService();
  private data: LiteratureViewModel[] = [];
  private condition: LiteratureViewModel = this.service.NewModel;

  private pageIndex: number = 1;

  private mounted() {
    this.loadData(1);
  }

  private loadData(page: number) {
    this.pageIndex = page;
    this.service.Search(this.condition, page).then((response: any) => {
      this.data = response;
    });
  }

  private btnSearch_OnClick() {
    this.loadData(1);
  }

  private page_OnChange(page: number) {
    this.loadData(page);
  }
}
